<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">SERVIÇOS</span>
                <div class="float-right">
                    <span class="text-primary">
                        <i
                            class="fa fa-refresh fa-lg icon-button"
                            title="Atualizar"
                            @click.stop="obterComprometimentos()"
                        ></i>
                    </span>
                </div>
            </b-card-header>

            <b-card-body>
                <b-alert
                    show
                    variant="warning"
                    v-if="comprometimentoEmAnaliseNaoComprometido"
                >
                    <h5>Atenção</h5>
                    <p>
                        Os serviços só podem ser aprovados se estiverem
                        comprometidos. Procure a <strong>UABS</strong> para
                        regularizar a situação dos serviços nas situações
                        <app-status status="NÃO COMPROMETIDO"></app-status> e
                        <app-status status="EM ANÁLISE"></app-status>.
                    </p>
                </b-alert>
                <app-tabela
                    :itens="comprometimentosFiltrados"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="botoes">
                        <b-row>
                            <b-col sm="12" md="12">
                                <b-form-group class="float-right">
                                    <strong>
                                        <label>Por Status</label>
                                    </strong>
                                    <b-form-select
                                        :plain="true"
                                        :options="statusSelect"
                                        v-model="status"
                                    ></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <slot name="botoes"></slot>
                    </template>
                    <template slot="valor" slot-scope="data">{{
                        data.valor | currency
                    }}</template>
                    <template slot="acoes" slot-scope="data">
                        <comprometimento-anexos
                            :comprometimento="data"
                            :dataServico="obterDataServico()"
                            :mostrarBtnInserir="mostrarBtnInserir(data)"
                            :mostrarBtnExcluir="mostrarBtnExcluir(data)"
                            @obter-atualizacao="obterComprometimentos()"
                        ></comprometimento-anexos>
                        <comprometimento-aprovadores
                            :comprometimento="data"
                            :dataServico="obterDataServico()"
                        >
                        </comprometimento-aprovadores>
                        <comprometimento-aprovar
                            v-if="mostrarBtnAprovar(data)"
                            :comprometimento="data"
                            :dataServico="obterDataServico()"
                            @obter-atualizacao="obterComprometimentos()"
                        >
                        </comprometimento-aprovar>
                        <comprometimento-reprovar
                            v-if="mostrarBtnReprovar(data)"
                            :comprometimento="data"
                            :dataServico="obterDataServico()"
                            @obter-atualizacao="obterComprometimentos()"
                        >
                        </comprometimento-reprovar>
                        <btn-justificativas-reprovacao
                            :comprometimento="data"
                        ></btn-justificativas-reprovacao>
                        <comprometimento-aprovacao
                            :comprometimento="data"
                        ></comprometimento-aprovacao>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import ComprometimentoAnexos from '../comprometimentos/ComprometimentoAnexos'
import ComprometimentoReprovar from './ComprometimentoReprovar'
import ComprometimentoAprovar from './ComprometimentoAprovar'
import ComprometimentoAprovadores from '../comprometimentos/ComprometimentoAprovadores'
import AprovadoresServicos from './AprovadoresServicos.js'
import { comprometimentoStatus } from '../comprometimentos/ComprometimentoStatus'
import { comprometimentoSituacao } from '../comprometimentos/ComprometimentoSituacao'
import BtnJustificativasReprovacao from '../comprometimentos/BtnJustificativasReprovacao'
import ComprometimentoAprovacao from './ComprometimentoAprovacao'

export default {
    data() {
        return {
            statusSelect: [
                { text: 'TODOS', value: -2 },
                { text: 'EM ABERTO', value: 0 },
                { text: 'EM ANÁLISE', value: 1 },
                { text: 'APROVADA', value: 2 },
                { text: 'REPROVADA', value: 3 }
            ],
            status: 1,
            comprometimentos: [],
            erros: [],
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações',
                    tdClass: 'text-center'
                },
                {
                    key: 'idComprometimento',
                    label: 'Id',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'processo',
                    label: 'Processo',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'contrato',
                    label: 'Contrato',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'fornecedor',
                    label: 'Fornecedor',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'tipo',
                    label: 'Tipo',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap',
                    type: 'status'
                },
                {
                    key: 'dataEmissao',
                    label: 'Data de Emissão',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-center',
                    type: 'date'
                },
                {
                    key: 'dataMovimento',
                    label: 'Data do Movimento',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-center',
                    type: 'date'
                },
                {
                    key: 'historico',
                    label: 'Histórico',
                    filterable: true
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'idRm',
                    label: 'ID RM',
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'situacao',
                    label: 'Situação',
                    type: 'status'
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    type: 'status'
                },
                {
                    key: 'qtdAnexos',
                    label: 'Qtd. Anexos'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime',
                    tdClass: 'text-nowrap text-center'
                }
            ],
            itensPorPagina: 10
        }
    },

    methods: {
        obterComprometimentos() {
            this.$store.dispatch('addRequest')
            AprovadoresServicos.obterComprometimentos().then((response) => {
                if (response) {
                    if (response.success) {
                        this.comprometimentos = response.data
                    } else {
                        this.erros = ['Erro ao obter atividades']
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterDataServico() {
            return AprovadoresServicos
        },

        mostrarBtnInserir(comprometimento) {
            return (
                comprometimento.status == comprometimentoStatus.EM_ANALISE &&
                this.$temAcessoView('GESCON-COMP-APROV-00')
            )
        },

        mostrarBtnExcluir(comprometimento) {
            return (
                comprometimento.status == comprometimentoStatus.EM_ANALISE &&
                this.$temAcessoView('GESCON-COMP-APROV-00')
            )
        },

        mostrarBtnReprovar(comprometimento) {
            return (
                comprometimento.status == comprometimentoStatus.EM_ANALISE &&
                this.$temAcessoView('GESCON-COMP-APROV-00')
            )
        },

        mostrarBtnAprovar(comprometimento) {
            let anexosOk = true
            if (comprometimento.contratoTipoEspecial) {
                anexosOk = comprometimento.qtdAnexos > 0
            }
            return (
                comprometimento.status == comprometimentoStatus.EM_ANALISE &&
                anexosOk &&
                comprometimento.idRm > 0 &&
                this.$temAcessoView('GESCON-COMP-APROV-00')
            )
        }
    },

    created() {
        this.obterComprometimentos()
    },

    computed: {
        comprometimentosFiltrados() {
            if (this.status == -2) {
                return [...this.comprometimentos]
            } else {
                return this.comprometimentos.filter(
                    (p) => p.status == this.status
                )
            }
        },

        comprometimentoEmAnaliseNaoComprometido() {
            return this.comprometimentos.find(
                (p) =>
                    p.status == comprometimentoStatus.EM_ANALISE &&
                    (p.idSituacao == comprometimentoSituacao.NAO_COMPROMETIDO ||
                        p.idSituacao ==
                            comprometimentoSituacao.SEM_COMPROMETIMENTO)
            )
        }
    },

    watch: {},

    components: {
        ComprometimentoAnexos,
        ComprometimentoReprovar,
        ComprometimentoAprovadores,
        BtnJustificativasReprovacao,
        ComprometimentoAprovar,
        ComprometimentoAprovacao
    }
}
</script>
